<template>
  <div
    class="columns is-flex-wrap-wrap member-form"
    @click="$emit('click')">
    <div
      v-if="isCreateMode"
      class="column is-full member-form__header clickable">
      <span>{{ index + 1 }}.</span>
      <div class="member-form__header--right">
        <a v-if="index > 0" href="#" @click.prevent="onRemove">
          <span class="icon-trash" />
        </a>
        <a
          href="#"
          :disabled="isActive"
          @click.prevent="$emit('click')">
          <span
            class="ml-6"
            :class="isActive ? 'icon-up-chevron' : 'icon-right-chevron'" />
        </a>
      </div>
    </div>
    <div class="column is-two-thirds">
      <slot name="title" />
      <b-field horizontal label="人員編號">
        <b-input v-model="member.member_detail.serial" name="serial" expanded />
      </b-field>
      <b-field
        horizontal
        :type="{ 'is-danger': invalidAccount }"
        :message="accountFieldMessage">
        <template #label>
          <span class="required">帳號</span>
        </template>
        <div class="member-form__account-field">
          <b-input
            v-model="member.account"
            name="account"
            class="member-form__account-field--input"
            expanded
            :disabled="!isCreateMode"
            @input="v$.member.account.$touch" />
        </div>
      </b-field>
      <b-field horizontal class="member-form__role">
        <template #label>
          角色<b-tooltip
            multilined
            type="is-dark"
          >
            <i class="icon-help-circle-outline text-gray-500" />
            <template v-slot:content>
              <ol>
                <li>一般身份僅可使用前台。</li>
                <li>團主可新增、編輯訂購及店家。</li>
                <li>管理員權限包含團主權限、新增人員及統計報表。</li>
              </ol>
            </template>
          </b-tooltip>
        </template>
        <b-radio
          v-for="role in filteredRoleMapping"
          v-model="member.role"
          :name="`role-${index}`"
          :native-value="role.key"
          :disabled="!isRoleAvailable(role.key)"
          :key="`role-${role.key}`">
          {{ role.name }}
        </b-radio>
      </b-field>
      <b-field
        horizontal
        :type="{ 'is-danger': invalidName }"
        :message="nameFieldMessage">
        <template #label>
          <span class="required">姓名</span>
        </template>
        <b-input
          v-model="member.member_detail.name"
          name="name"
          expanded
          @input="v$.member.member_detail.name.$touch" />
      </b-field>
      <template v-if="isActive">
        <b-field horizontal label="單位">
          <b-select
            v-model="member.department_id"
            placeholder="單位"
            class="member-form__department"
            :disabled="!departments.length"
            expanded>
            <option
              v-for="department in departments"
              :value="department.id"
              :key="department.id">
              {{ department.name }}
            </option>
          </b-select>
        </b-field>
      </template>
      <b-field
        horizontal
        :type="{ 'is-danger': invalidEmail }"
        :message="emailFieldMessage">
        <template #label>
          <span>Email</span>
        </template>
        <div class="member-form__email-field">
          <b-input
            v-model="member.email"
            name="email"
            type="email"
            class="member-form__email-field--input"
            expanded
            @input="v$.member.email.$touch" />
        </div>
      </b-field>
      <div v-if="isActive" class="member-form__detail">
        <b-field
          horizontal
          :type="{ 'is-danger': invalidExtension }"
          :message="extensionFieldMessage"
          label="分機/電話">
          <b-input v-model="member.member_detail.ext" name="ext" expanded />
        </b-field>
        <b-field
          horizontal
          :type="{ 'is-danger': invalidMobile }"
          :message="mobileFieldMessage"
          label="手機號碼">
          <b-input
            v-model="member.member_detail.phone"
            expanded
            name="phone"
            type="tel"
            @input="v$.member.member_detail.phone.$touch"
          />
        </b-field>
        <b-field
          horizontal
          :type="{ 'is-danger': invalidAllowOrderOnSite }"
          :message="allowOrderOnSiteFieldMessage">
          <template #label>
            <span class="required">可現場訂單次數</span>
          </template>
          <div class="member-form____allow-order-field">
            <b-input
              v-model="member.allow_order_on_site"
              name="allow_order_on_site"
              type="allow_order_on_site"
              class="member-form__allow-order-field--input"
              expanded
              @keypress.native="onInputNonDigit"
              @input="v$.member.allow_order_on_site.$touch" />
          </div>
        </b-field>
        <b-field horizontal label="備註">
          <b-input
            v-model="member.member_detail.note"
            :has-counter="false"
            name="note"
            maxlength="40"
            placeholder="可以記錄關於人員的點點滴滴"
            expanded />
        </b-field>
      </div>
    </div>
    <div
      v-if="$slots.action"
      class="column is-full">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
import MemberForm from './MemberForm';

export default MemberForm;
</script>

<style lang="scss" scoped>
@import './MemberForm.scss';
</style>
